// extracted by mini-css-extract-plugin
export default {"authPage":"auth_authPage__6ariy","authForm":"auth_authForm__qt2xL","submitButton":"auth_submitButton__fHyms","authTitle":"auth_authTitle__7lim5","authPush":"auth_authPush__yb347"};